import { render } from "./PriceTable.vue?vue&type=template&id=6ade11f4&scoped=true&ts=true"
import script from "./PriceTable.vue?vue&type=script&lang=ts"
export * from "./PriceTable.vue?vue&type=script&lang=ts"

import "./PriceTable.vue?vue&type=style&index=0&id=6ade11f4&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ade11f4"]])

export default __exports__